{
  "el": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Αλλαγή λογότυπου (απαιτείται png)",
        "changeThemeColor": "Επιλογή νέου χρώματος θέματος"
      },
      "labels": {
        "customerThemeColor": "Χρώμα θέματος πελάτη",
        "customerThemeColorExlainer": "Αυτό το χρώμα θα χρησιμοποιείται στην πύλη πελάτη. Κάνε υπόδυση ενός πελάτη για να το δεις σε δράση.",
        "logo": "Λογότυπο"
      },
      "picture_logo_format": {
        "round": "Στρογγυλό λογότυπο",
        "square": "Τετράγωνο λογότυπο"
      }
    }
  }
}
